<main class="dialog-body">
  <div class="dialog-header">
    <div class="dialog-header-text">
      {{ isEditMode ? "Edit" : "Create new" }} work experience
    </div>
    <div class="cros-icon" (click)="onCancel()">
      <img src="assets/images/cross-icon.svg" class="cross-icon" />
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="form" class="form-group-container d-grid">
      <div class="form-group-item-flex">
        <div class="form-group-item">
          <app-input
            context="Normal"
            class="form-item"
            label="Event name"
            placeholder="Enter your event name"
            type="text"
            [control]="form.get('eventName')"
            [required]="true"
            formControlName="eventName"
            [customErrorMessages]="customErrorMessages.eventName"
            [disabled]="true"
          >
          </app-input>
        </div>

        <!-- <div class="form-group-item">
          <app-input
            context="Normal"
            label="Status"
            placeholder="Select status"
            type="select"
            [control]="form.get('status')"
            [options]="statusOption"
            [required]="true"
            [customErrorMessages]="customErrorMessages.status"
          >
          </app-input>
        </div> -->
      </div>

      <div class="date-time-section mt-3">
        <div class="date-section">
          <div class="event-date-container">
            <div class="form-group">
              <app-input
                context="Normal"
                label=""
                placeholder="From"
                type="date"
                label="Start date"
                [control]="form.get('fromDate')"
                (dateChange)="calculateDays()"
                [required]="true"
                [disableWeekends]="true"
                [customErrorMessages]="customErrorMessages.fromDate"
                (change)="calculateDays()"
              >
              </app-input>
            </div>

            <div class="form-group">
              <app-input
                context="Normal"
                label=""
                placeholder="To"
                type="date"
                label="End date"
                [disableWeekends]="true"
                [required]="true"
                [control]="form.get('toDate')"
                (dateChange)="calculateDays()"
                (change)="calculateDays()"
                [min]="getMinEndDate()"
                [customErrorMessages]="customErrorMessages.toDate"
              >
              </app-input>
            </div>

            <div class="form-group">
              <app-input
                context="Normal"
                label=""
                placeholder="0"
                type="text"
                label="No.of days"
                [control]="form.get('noOfDays')"
                [customErrorMessages]="customErrorMessages.noOfDays"
              >
              </app-input>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 mt-3">
        <div class="Normal-label">
          Start & end time <span class="req-star">*</span>
        </div>
        <div class="form-group">
          <app-input
            context="Normal"
            label=""
            placeholder="Select time"
            type="time"
            [control]="form.get('eventTime')"
            [customErrorMessages]="{
              required: 'Please enter start and end time.',
              invalidFormat: 'Invalid time format. Use HH:mm format',
              timeRange: 'End time must be after start time',
            }"
          >
          </app-input>
        </div>
      </div>

      <div class="form-group-item mt-3">
        <app-input
          context="Normal"
          class="form-item"
          label="Company / Employer"
          placeholder="Enter name of company / Employer"
          type="text"
          [required]="true"
          [control]="form.get('employerName')"
          formControlName="employerName"
          [customErrorMessages]="customErrorMessages.employerName"
        >
        </app-input>
      </div>

      <div class="form-group-item mt-3">
        <app-input
          context="Normal"
          label="Location"
          placeholder="Select location"
          type="text"
          [control]="form.get('location')"
          [required]="true"
          formControlName="location"
          [customErrorMessages]="customErrorMessages.location"
        >
        </app-input>
      </div>

      <div class="form-group-item mt-3">
        <app-input
          context="Normal"
          class="form-item"
          label="Type of Work Experience"
          placeholder="Select your work experience"
          type="select"
          [control]="form.get('workExperinceType')"
          [options]="workExperinceTypeOption"
          [required]="true"
          [customErrorMessages]="customErrorMessages.workExperinceType"
        >
        </app-input>
      </div>

      <div class="image-upload-container mt-3">
        <label>Upload Evidence</label>
        <div
          class="image-upload-item"
          [class.drag-over]="isDragOver"
          (click)="fileInput.click()"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
        >
          <div class="justify-content-center" style="justify-items: center">
            <img class="upload-icon" src="assets/images/image-add.svg" />
            <input
              #fileInput
              type="file"
              (change)="onFileSelected($event)"
              accept=".pdf"
              hidden
              multiple
            />
            <h5>Drag & drop file or <span>browse</span></h5>
            <h6>Supported formats: PDF.</h6>
          </div>
          <div
            class="uploaded-images-container"
            *ngIf="uploadedFiles.length > 0"
          >
            <div class="uploaded-images-header">Uploaded File</div>
            <div class="uploaded-images-grid">
              <div
                class="uploaded-image-item"
                *ngFor="let file of uploadedFiles; let i = index"
              >
                <img
                  *ngIf="file.type === 'image'"
                  [src]="file.previewUrl"
                  class="image-preview"
                  (error)="file.previewUrl = 'assets/images/image-error.svg'"
                  alt="Image preview"
                />

                <img
                  *ngIf="file.type === 'pdf'"
                  src="assets/images/pdf-icon.png"
                  class="image-preview pdf-icon"
                  alt="PDF document"
                />

                <div class="image-actions">
                  <span class="image-name" [title]="file.name"
                    >{{ file.name | slice: 0 : 15
                    }}{{ file.name.length > 20 ? "..." : "" }}</span
                  >
                  <button
                    class="remove-image-btn"
                    (click)="removeImage(i); $event.stopPropagation()"
                    type="button"
                  ></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="form-actions">
    <button
      type="button"
      class="btn-cancel"
      (click)="onCancel()"
      [disabled]="isSubmitting"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn-save"
      (click)="onSave()"
      [disabled]="isSubmitting"
    >
      {{ isSubmitting ? "Saving..." : isEditMode ? "Update" : "Save" }}
    </button>
  </mat-dialog-actions>
</main>

<div class="overlay-item"></div>
